/** sessionStorage key for ?ref= slug pending first sign-in */
export const PENDING_REF_STORAGE_KEY = "tml_pending_ref";
